module.exports = {"TXTWCL_WEXLL_BE_BACK_SOONX":{"id":"TXTWCL_WEXLL_BE_BACK_SOONX","defaultMessage":"ΘA ΕΠΙΣΤΡΕΨΟΥΜΕ ΣΥΝΤΟΜΑ!"}}